/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  jQuery("#nav0").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 3,
    scroll: 2,
  });
  new Swiper(".sp-swiper3", {
    speed: 8000,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 1,
    },
    slidesPerView: "auto",
    loop: true,
    spaceBetween: -9,
  });

  new Swiper(".sp-swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,

    spaceBetween: 10,
    pagination: {
      el: ".sp-pagination2",
      type: "bullets",
      clickable: true,
    },
  });
  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-p1-o.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-p2-o.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-p2-o.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-p1-b.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-p2-b.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-p2-b.png",
  ];
  let spImgList2 = [
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-c1.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-c2.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-b1.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-b2.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-b3.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-b4.png",
    "https://cdn.shopify.com/s/files/1/0660/2122/8780/files/20240927-b5.png",
  ];

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);
    preloadImages(spImgList2);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            221 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  $(function () {
    $(".option").click(function () {
      $(this).addClass("active").siblings().removeClass("active");
      let sp_img = $(this).parents(".product-box");
      let _numIndex = sp_img.index();
      let _sizeIndex = $(this).index();
      let spUrl = spImgList[_numIndex + _sizeIndex * 3];
      sp_img.css("backgroundImage", "url('" + spUrl + "')");
    });
  });

  $('.cart-btn').click(function(){
    let id = $(this).siblings('.sp-opt-wrap').find('div.active').attr('data-id')
    window.location.href = '/cart/' + id + ':1'
  })
});
